export function openNotificationModal(notificationType) {
  return {
    type: 'OPEN_NOTIFICATION_MODAL',
    notificationType,
  };
}

export function closeNotificationModal(notificationType) {
  return {
    type: 'CLOSE_NOTIFICATION_MODAL',
    notificationType,
  };
}
